import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ca-rbr-section',
    templateUrl: './section.component.html',
    styleUrl: './section.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionComponent {}
